import React, {useCallback, useEffect, useReducer, useState} from "react";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button"
import Table, {TableCell, TableRow} from "@amzn/meridian/table"
import {DriverListReducer} from "./reducers/DriverListReducer";
import Loader from "@amzn/meridian/loader";
import Checkbox from "@amzn/meridian/checkbox"
import minusIconTokens from "@amzn/meridian-tokens/base/icon/minus"
import Alert from "@amzn/meridian/alert";
import Column from "@amzn/meridian/column";
import Pagination from "@amzn/meridian/pagination";
import {FormattedMessage} from "react-intl";
import {PrintStoreReconciliationSheetDialog} from "../storeReconciliationSheet/PrintStoreReconciliationSheetDialog";

const DRIVER_ATTRIBUTES = [
    ["DRIVER_NAME", {stringId: "tracking_id"}],
    ["DRIVER_ID", {stringId: "shipment_type"}],
    ["IS_STORE", {stringId: "store"}],
];

const PAGE_SIZE = 50;

const initialState = {
    drivers: [],
    loading: false,
    success: true
};

export const StoreReconciliationSheet = (props) => {
    const [{drivers, loading, success}, dispatch] = useReducer(DriverListReducer, initialState);
    const [openCASDialog, setOpenCASDialog] = useState(false);
    const onClickCASButton = useCallback(() => setOpenCASDialog(true), []);
    const [checked, setChecked] = useState([]);

    const actualDriverSize = drivers.filter(packages => packages.IS_STORE === true);
    console.log(openCASDialog);
    const [currentPage, setCurrentPage] = useState(1);
    const pageCount = Math.ceil(actualDriverSize.length/PAGE_SIZE);

    const currentPagePackages = drivers.filter(packages => packages.IS_STORE === true)
        .slice( (currentPage - 1)*PAGE_SIZE, currentPage*PAGE_SIZE );



    useEffect(() => {
        const filters = props.filters;
        dispatch({
            type: "LOAD_DATA",
            data: {filters, dispatcher: dispatch}
        })
    }, []);

    const onCheckChanged = (key) => {
        const newRow = currentPagePackages[key].DRIVER_ID;
        checked.includes(newRow) ? setChecked(old => old.filter(row => row !== newRow)) : setChecked(old => [...old, newRow]);
    };
    const isCheckedRow = (index) => {
        return checked.includes(currentPagePackages[index].DRIVER_ID) === true;
    };
    const areAllRowsChecked = () => {
        return checked.length === currentPagePackages.length;
    };
    const checkAllRows = (e) => {
        currentPagePackages.map(item => {
            if (e) {
                checked.includes(item.DRIVER_ID) ?
                    setChecked(old => [...old]) : setChecked(old => [...old, item.DRIVER_ID]);
            } else if(!e){
                setChecked([]);
            }
            return true;
        });

    };
    if (loading) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Loader type="circular"/>
        </Row>)
    }
    if (!success) {
        return (<Row alignmentHorizontal="center" alignmentVertical="center" height="100%" minHeight="460px">
            <Alert type="error"></Alert>
        </Row>)
    }
    return (
        <Column spacingInset="small large">
            <Box>
                <Row width="100%" widths="fill" spacing="medium" spacingInset="medium">
                    <Column>
                        <Text type="h600">Driver List</Text>
                    </Column>
                    <Column>
                        <Row alignmentHorizontal="right">
                            <Button onClick={onClickCASButton} disabled={checked.length === 0} type="tertiary">
                                Print Store Reconciliation Sheet</Button>
                        </Row>
                    </Column>
                </Row>
                <Box>
                    <Table headerRows={1} spacing="small">
                        <HeaderRow isChecked={areAllRowsChecked} checkAll={checkAllRows}/>

                    {currentPagePackages.filter(packages => packages.IS_STORE === true).map((item, index) => (
                            <TableRow key={item.DRIVER_ID}>
                                <TableCell>
                                    <Checkbox checked={isCheckedRow(index)} onChange={(e) => onCheckChanged(index, e)}/>
                                </TableCell>
                                {
                                    DRIVER_ATTRIBUTES.map(([a, b], index) => {
                                        return (<TableCell key={index}>{item[a]}</TableCell>);
                                    })
                                }
                            </TableRow>
                        ))}
                    </Table>
                </Box>
                {openCASDialog && <PrintStoreReconciliationSheetDialog isModalOpen={openCASDialog} onModelOpenChange={setOpenCASDialog}
                                                    checkedDrivers={checked}/>}

                <Row width="100%" widths="fill" >
                    <Box>
                        <Text type="b200" >
                            Showing { Math.min((currentPage - 1)*PAGE_SIZE + 1 , actualDriverSize.length)} to {Math.min((currentPage - 1)*PAGE_SIZE + PAGE_SIZE, actualDriverSize.length)} of {actualDriverSize.length}
                        </Text>
                    </Box>
                    <Row alignmentHorizontal="right" >
                        { (pageCount > 1) && <Pagination
                            numberOfPages={pageCount}
                            onChange={ (e) => {
                                setChecked([]);
                                setCurrentPage(e)
                            }}
                            currentPage={currentPage}
                        />
                        }
                    </Row>
                </Row>
            </Box>
        </Column>
    )
};

function HeaderRow({isChecked, checkAll}) {
    return <TableRow key={"top"}>
        <TableCell key="selectall">
            <Checkbox checked={isChecked()} onChange={(e) => checkAll(e)} iconTokens={minusIconTokens}/></TableCell>
        <TableCell><FormattedMessage id="driver_name" defaultMessage="Name"/></TableCell>
        <TableCell><FormattedMessage id="driver_id" defaultMessage="Id"/></TableCell>
    </TableRow>
}

HeaderRow.WrappedComponent = TableRow;


// WEBPACK FOOTER //
// ./src/components/storeReconciliationSheet/StoreReconciliationSheet.js